module.exports = __webpack_public_path__ + "img/info_center_icon2.848fd810.jpg";